import React from 'react';

import '../styles/pool-details.css';
import { countShares } from 'features/SpilKlub/state/helpers';

const AddSharesButton = ({
    selectShares,
    onChange = () => {},
    pool,
    onSharesClick = () => {},
    setSharesButton = () => {},
}) => {
    const sharesLeft = pool
        ? pool?.poolSettings?.sharesLimit - countShares(pool)
        : 0;

    return (
        <div className={'sk-pools-select-shares'} onClick={onSharesClick}>
            <div
                className={'sk-pools-shares-button'}
                onClick={(e) => {
                    e.stopPropagation();
                    onChange((prevState) => {
                        if (prevState === 1) {
                            setSharesButton(true);
                            return prevState;
                        } else {
                            return prevState > 1 ? prevState - 1 : prevState;
                        }
                    });
                }}
            >
                <hr width={'10px'} size={3} color={'#ECEFF7'} />
            </div>
            {selectShares}
            <div
                className={'sk-pools-shares-button'}
                key={'right'}
                onClick={(e) => {
                    e.stopPropagation();
                    onChange(
                        (prevState) =>
                            prevState < sharesLeft ? prevState + 1 : prevState
                    );
                }}
            >
                <hr width={'10px'} size={3} color={'#ECEFF7'} />
                <hr
                    width={'10px'}
                    size={3}
                    color={'#ECEFF7'}
                    className={'plus'}
                />
            </div>
        </div>
    );
};

export default AddSharesButton;
